import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { useSelector } from 'react-redux';
import { fromOrder } from '../../../../store';
import { PriceRows } from './PriceRows';
import { formatCurrency } from '../../../../components';
import { DEFAULT_CURRENCY_FORMAT_OPTIONS } from '../../../../utils/Constants';

const useStyles = makeStyles(theme => ({
  totalRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 0),
  },
  totalLabel: {
    fontWeight: 700,
    fontSize: 15,
    color: '#22283c',
  },
  totalAmount: {
    fontWeight: 800,
    fontSize: 24,
    color: '#0F8461',
  },
}));

export const PriceSummary = (
  { isAnnual }: {
    isAnnual: boolean;
  },
) => {
  const classes = useStyles();
  const intl = useIntl();
  const orderPreviewResponse = useSelector(fromOrder.selectOrderPreviewResponse);
  const totalPrice = useSelector(fromOrder.selectPreviewsTotal);

  return (
    <Box
      id="price-summary"
      display="flex"
      flexDirection="column"
    >
      <Typography variant="h4" fontWeight={600} lineHeight="135%">
        <FormattedMessage id="page.plan.v2.plan.price.details.title" />
      </Typography>
      {orderPreviewResponse && orderPreviewResponse.productsPreview.length > 0
        && (
          <PriceRows
            isAnnual={isAnnual}
            productsPreview={orderPreviewResponse.productsPreview[0]}
          />
        )}

      {/* Annual total */}
      <Box className={classes.totalRow}>
        <Typography className={classes.totalLabel}>
          <FormattedMessage
            id="page.plan.v2.total"
          />
        </Typography>
        <Typography className={classes.totalAmount}>
          {formatCurrency(intl, totalPrice ?? 0, DEFAULT_CURRENCY_FORMAT_OPTIONS)}
        </Typography>
      </Box>
    </Box>
  );
};
